import useSWR from "swr";
import { useContext } from "react";
import { TaskModel } from "@attelas/shared";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { ToastContext } from "../context/ToastContext";

export const useTasksContact = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<TaskModel[]>(
    `${environment.apiUrl}/api/contacts/tasks`,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get tasks, please try again later", "error");
      },
    }
  );

  return {
    tasks: data,
    isLoading,
    isError: !!error,
  };
};
